import raw from "../../data/tables/art/packs/portal-ffa/grips.json";
import type { GripPack } from "./grip-resolve";

/** Portal FFA grip SSOT — seeded from Dropfront kits; JSON tuples cast once. */
export const portalFfaGripPack = raw as unknown as GripPack;
